import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m16.566 9.667-6.533-6.534A1.22 1.22 0 0 1 9.65 2.2q.016-.533.416-.933.4-.367.934-.384.533-.016.933.384l8.8 8.8q.2.2.283.433.084.233.084.5t-.084.5-.283.433l-8.8 8.8q-.367.367-.917.367t-.95-.367a1.3 1.3 0 0 1-.4-.95q0-.55.4-.95l6.5-6.5h-14.9a1.3 1.3 0 0 1-.95-.383A1.3 1.3 0 0 1 .333 11q0-.566.383-.95a1.3 1.3 0 0 1 .95-.383z"
    }, null, -1)
  ])))
}
export default { render: render }